import { render, staticRenderFns } from "./ObjekteListe.vue?vue&type=template&id=25a9e74c&scoped=true"
import script from "./ObjekteListe.vue?vue&type=script&lang=js"
export * from "./ObjekteListe.vue?vue&type=script&lang=js"
import style0 from "./ObjekteListe.vue?vue&type=style&index=0&id=25a9e74c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a9e74c",
  null
  
)

export default component.exports